import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCollection = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M24.47 3.5h-2.46c-.44 0-.85.18-1.16.51-.31.33-.48.77-.48 1.24v17.5c0 .46.17.91.48 1.24.31.33.73.51 1.16.51h2.46c.44 0 .85-.18 1.16-.51.31-.33.48-.77.48-1.24V5.25c0-.46-.17-.91-.48-1.24-.31-.33-.73-.51-1.16-.51ZM22 22.75h2.46V5.25H22v17.5ZM17.09 3.5h-2.46c-.44 0-.85.18-1.16.51-.31.33-.48.77-.48 1.24v17.5c0 .46.17.91.48 1.24.31.33.73.51 1.16.51h2.46c.44 0 .85-.18 1.16-.51.31-.33.48-.77.48-1.24V5.25c0-.46-.17-.91-.48-1.24-.31-.33-.73-.51-1.16-.51Zm-2.46 19.25h2.46V5.25h-2.46v17.5ZM2.92 23.82l2.38.64c.42.11.87.04 1.25-.19.38-.24.66-.62.78-1.07l4.53-16.91c.12-.45.07-.92-.14-1.32-.21-.4-.57-.68-.99-.8l-2.38-.64c-.42-.11-.87-.04-1.25.19s-.66.62-.78 1.07L1.78 21.71c-.12.45-.07.92.14 1.32.21.4.57.68.99.8l.01-.01Zm7.36-17.95L7.9 5.23l-4.53 16.9 2.38.64 4.53-16.9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCollection;
